import { useToast } from 'primevue/usetoast';

type Severity = 'success' | 'info' | 'warn' | 'error';

export interface NotifyOptions {
  life?: number;
  closable?: boolean;
  group?: string;
}

export interface Notifier {
  success(message: string, title?: string, options?: NotifyOptions): void;
  info(message: string, title?: string, options?: NotifyOptions): void;
  warn(message: string, title?: string, options?: NotifyOptions): void;
  error(message: string, title?: string, options?: NotifyOptions): void;
}

const DEFAULT_LIFE_MS = 4000;

const SEVERITY_TITLE: Record<Severity, string> = {
  success: 'Success',
  info: 'Info',
  warn: 'Warning',
  error: 'Error',
};

export function useNotifier(): Notifier {
  const toast = useToast();

  function show(severity: Severity, message: string, title?: string, opts?: NotifyOptions): void {
    toast.add({
      severity,
      summary: title ?? SEVERITY_TITLE[severity],
      detail: message,
      life: opts?.life ?? DEFAULT_LIFE_MS,
      closable: opts?.closable ?? true,
      group: opts?.group ?? undefined,
    });
  }

  return {
    success: (m, t, o) => show('success', m, t, o),
    info: (m, t, o) => show('info', m, t, o),
    warn: (m, t, o) => show('warn', m, t, o),
    error: (m, t, o) => show('error', m, t, o),
  };
}
